import Api from 'src/api/Base'

class GetStores extends Api {
  requestUrl = `/api/Store`
}

export default GetStores
